fieldLabel:
  address: Address
  addressLine1: Address Line 1
  addressLine2: Address Line 2
  altPhone: Mobile Phone Number
  apa: APA %
  applyBranding: Apply branding
  associations: Associations
  basePrice: Base Price
  billingEmails: Receive billing emails
  brochureUri: Brochure URI
  cabins: Cabins
  caption: Caption
  cardCvv: CVV
  cardExpiry: Expiry Date
  cardName: Cardholder Name
  cardNumber: Card Number
  central: Fleet Editor
  city: City
  companyAccountant: Accountant
  companyAdmin: Administrator
  country: Country
  confirmPassword: Confirm Password
  currency: Currency
  currencyCode: Currency Display
  currentPassword: Current Password
  customerName: Customer's Name
  dates: Dates
  destination: Destination
  email: Email Address
  emailCc: CC
  emailText: Body
  emailTo: To
  expense: Expense
  firstName: First Name
  friendly: Friendly
  lastName: Last Name
  legalName: Legal Name
  message: Message
  metric: Measurement Units
  name: Name
  newPassword: New Password
  office: Office
  phone: Office Phone Number
  phoneOffice: Office Phone Number
  postcode: ZIP / Postcode
  priorName: Previous Name
  q: Search
  season: Season
  state: State / County
  subAreas: Sub-areas
  subscriptionEmails: Receive subscription emails
  tax: Tax %
  text: Text
  title: Title
  url: URL
  vatNumber: VAT Number
  website: Website
  yearLaunch: Launched
  yearRefit: Refit
  lengthMeters: Length
  beamMeters: Beam
  draftMeters: Draft
  builder: Builder
  designer: Exterior Designer
  interiorDesigner: Interior Designer
  hull: Hull
  category: Type
  construction: Material
  engine: Engine(s)
  divingInsured: Diving Insured
  divingCosts: Diving Costs
  divingCertification: Crew Certification
  scubaTanks: Scuba Tanks
  buoyancyCompensators: Scuba BC
  regulators: Regulators
  compressors: Compressors
  mcaStatus: Maritime & Coastguard Agency (MCA)
  flagCountry: Flag
  registryPort: Registry
  vatRegistered: Charterable to E.U. residents in E.U. waters
  usaDuty: Charterable to U.S. residents in U.S. waters
  fuelMaxLPH: Fuel Max
  fuelCruiseLPH: Fuel Cruising
  rangeMaxKm: Range Max
  rangeCruiseKm: Range Cruising
  speedMaxKPH: Speed Max
  speedCruiseKPH: Speed Cruising
  voltage: Voltage
  smoking: Smoking
  masterCabinLocation: Primary Cabin
  crewCabinLocation: Crew Cabin
  guestsEntertaining: Guests Entertaining
  guestsSleeping: Guests Sleeping
  guestsCruising: Guests Cruising
  duration: Duration
  guests: Guests
  renew: Auto-renew
  status: Staus
  pickupPort: Pickup Location
  dropOffPort: Drop-off Location
  captainName: Captain Name
  captainEmail: Captain Email
  captainPhoneCell: Captain Cell Phone
  ownerName: Owner Name
  ownerEmail: Owner Email
  ownerPhoneCell: Owner Cell Phone
  crewSize: Total Crew
  crewLanguage: Principal Language
  phoneCell: Yacht Cell Phone
  phoneSat: Yacht Sat Phone
latLong:
  label: Lat (N) / Long (E)
  placeholder: Latitude (N), Longitude (E)
  error: 'Invalid Latitude / Longitude.'
validation:
  phoneNumber: 'Enter a valid phone number'
upload:
  invalidType
